// extracted by mini-css-extract-plugin
module.exports = {"Notification":"_2sPToqG1","title":"Dym5dZek","text":"_3ptahsfj","actionButtons":"_2dByIAO9","appear":"_3kUF11IP","appearActive":"_2jCEmRwK"};
    if(module.hot) {
      // 1746735760273
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  